import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {Button} from "reactstrap";
import {downloadDocument} from "../../../../../idoa/app/actions/download";
import {handleApiResponse} from "../../../crud-actions";
import ContentShow from "../../content-editor/content-show";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class MedicalExamDownload extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            downloading: false
        }
    }

    downloadDocument(id) {
        this.setState({...this.state, downloading: true});
        this.props.downloadDocument(id).then((response) => {
            this.setState({...this.state, downloading: false});

            if (response.type === 'DOCUMENT_DOWNLOAD_SUCCESS') {
                window.open(response.payload.url);
                this.markAsDone(false).then(() => {
                    const assignmentId = this.props.assignment.id;
                    this.props.selectAssignment('api/v1', assignmentId);
                }) ;
            } else {
                this.setState({...this.state, downloading: false});
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            }
        })
    }

    markAsDone = (notify = true) => {
        const assignmentId = this.props.assignment.id;
        let promise = this.props.assignmentAction('api/v1', assignmentId, { execute: 'mark_as_done' });
        return handleApiResponse('ASSIGNMENT','ACTION', promise,
            (response) => {
                if (notify) {
                    this.props.push('/dashboard/');
                    this.props.setNotification('success', this.props.intl.formatMessage({id: "app.content_units.mark_as_done.success"}));
                }
            },
            (response) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            },
            (response) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            });
    };

    render() {
        const { assignment } = this.props;
        let document = assignment.employee_data.document;
        const contentUnit = assignment.content_unit;
        const state = assignment.state;

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                    <hr/>
                    { !document &&
                        <p>
                            <FormattedMessage id='app.medical_exams.not_yet_uploaded'/>
                        </p>
                    }
                    { document &&
                        <Button color='primary' disabled={this.state.downloading} onClick={() => { this.downloadDocument(document.id) }}><FormattedMessage id='app.actions.download'/>{ this.spinner(this.state.downloading) }</Button>
                    }
                    {
                        document && state !== 'complete' &&
                        <div>
                            <hr/>
                            <Button onClick={this.markAsDone}><FormattedMessage id='app.actions.mark_as_done'/></Button>
                        </div>
                    }
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        constants: state.constants
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        downloadDocument: downloadDocument,
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(MedicalExamDownload));
